// import Rater from 'react-rater'
import FitText from '@kennethormandy/react-fittext'
import { Rate } from 'antd'
import React from 'react'
import styled from 'styled-components'
import { Cell } from '../../styles/styled-common'

const A = styled.a`
  font-size: 20px;
  text-align: center;
  color: ${p => p.theme.textOffwhite};
  width: 100%;
  line-height: 1.3;
`

export default class RatingCell extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = { track: false }
  }

  _trackAffiliate = () => {
    if (!this.state.track) this.setState({ track: true })
  }

  render() {
    const {
      rating: { score, stars, url, reviewCount },
      affiliateUrl,
      fitText = true,
      ...props
    } = this.props

    const rate = (
      <Rate disabled allowHalf={false} defaultValue={stars} count={5} />
    )
    const rating = fitText ? <FitText compressor={0.7}>{rate}</FitText> : rate

    return (
      <Cell {...props}>
        {this.state.track ? (
          <img
            alt=""
            width={1}
            height={1}
            style={{ marginTop: -20000, position: 'absolute' }}
            src={affiliateUrl}
          />
        ) : null}
        {/* Score is 10-based. divide it by 2 and ceil */}
        <A
          href={url}
          onClick={this._trackAffiliate}
          target="_blank"
          rel="nofollow noreferrer noopener"
        >
          <div>{score}</div>
          {rating} {reviewCount ? `(${reviewCount} reviews)` : null}
        </A>
      </Cell>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/RatingCell.jsx